import { ProductServiceItem } from './accounting';
import { DriverLicense } from './drivers-license-parser';
import { ObjectId } from 'mongodb';

export class FFL {
  id?: string;
  company_id?: string;
  ffl: string = '';
  legal_name: string | null = null; //license_name
  business_name: string | null = null;
  premise_street?: string | null = null;
  premise_city?: string | null = null;
  premise_state?: string | null = null;
  premise_zip_code?: string | null = null;
  phone_number: string | null = null; //voice_telephone
  email: string | null = null;
  notes: string | null = null;
  issue_date?: string | null = null;
  expiration_date: string | null = null;
  certified_ffl_blob_name?: string | null = null; // Blob storage filename
  updatedAt?: string;
}
export class YesNoResponse {
  answer: string;
  optional_details: {} = {};
  question?: string;
}
export class QuestionResponse {
  answer: string;
  optional_details: {} = {};
  question?: string;
}
export class saveProductServiceResponse {
  item: ProductServiceItem;
  rowIndex?: number;
}
export class CityInfo {
  zip_code: number;
  city: string;
  state: string;
  county: string;
}
export class Firearm {
  id?: string = null;
  company_id?: string;
  firearm_upc: string;
  firearm_type: string;
  manufacture: string;
  importer: string;
  model: string;
  additional_markings: string;
  caliber_gauge: string;
  updatedAt?: string;
}
export class BoundBook {
  _id?: string;
  company_id: string;
  bound_book_name: string;
  bound_book_id: string;
  default: boolean = false;
  entries: BoundBookEntry[] = [];
}

export class BoundBookEntry {
  _id?: string;
  firearm_id: number;
  state: string;
  notes: Note[] = [];
  event_log: EventEntry[] = [];
  // acquisition info
  a_firearm_upc: string;
  a_firearm_type: string;
  a_serial_number: string;
  a_manufacture: string;
  a_importer: string;
  a_model: string;
  a_caliber_gauge: string;
  a_additional_markings: string;
  a_ffl: string;
  a_received_from_name: string;
  a_address: string;
  a_address2: string;
  a_business_name: string;
  a_zip_code: string;
  a_state: string;
  a_city: string;
  a_date_acquired: string;
  // disposition info
  d_id?: string;
  d_ffl: string;
  d_disposed_to: string;
  d_business_name: string;
  d_form4473_id: string;
  d_first_name: string;
  d_middle_name: string;
  d_last_name: string;
  d_sr_name: string;
  d_address: string;
  d_address2: string;
  d_zip_code: number;
  d_state: string;
  d_city: string;
  d_date_disposed: string;
  updatedAt?: string;
}
export class Note {
  note_type: string;
  comment: string;
  username: string;
  dateTime: string;
}
export class EventEntry {
  username: string;
  event: string;
  value_changed_from: {};
  value_changed_to: {};
  date_time_stamp: string;
}
export class AddEditFirearmResponse {
  modal_type: string;
  form_values: Firearm;
}
export class AddEditFFLResponse {
  modal_type: string;
  form_values: FFL;
  certified_ffl_pdf_file?: File;
  remove_certified_ffl_pdf?: boolean;
}
export class Form4473 {
  _id?: string;
  company_id: string;
  firearms: Form4473Firearm[] = [];
  transferee: Form4473Transferee;
  transferor: Form4473Transferor;
  ffl: Form4473FFL;
  transaction_serial_number: string;
  form_4473_version: string;
  form_3310_version: string;
  continuation_sheet_version: string;
  form_3310_sent: boolean = false;
  createdAt?: any;
  updatedAt?: any;
}
export class Form4473Transferor {
  // Firearm transfer types
  transfer_handgun: boolean = false;
  transfer_long_gun: boolean = false;
  transfer_other_firearm: boolean = false;

  // Function details (for C&R or other special transfers)
  function_name: string | null = null;
  function_address: string | null = null;
  function_zip_code: string | null = null;
  function_city: string | null = null;
  function_state: string | null = null;
  function_county: string | null = null;

  // Identification
  id_issuing_authority: string = '';
  id_type_of_id: string = '';
  id_number: string = '';
  id_expiration_month: string = '';
  id_expiration_day: string = '';
  id_expiration_year: string = '';
  supplemental_id: string = '';

  // PCS (Permanent Change of Station) for military
  pcs_base_name: string | null = null;
  pcs_order_number: string | null = null;
  pcs_effective_month: string | null = null;
  pcs_effective_day: string | null = null;
  pcs_effective_year: string | null = null;

  // Alien exception
  exception_to_alien_prohibition: string | null = null;

  // NICS exemptions
  no_nics_nfa: boolean | null = null;
  no_nics_valid_permit: boolean = false;
  no_nics_valid_permit_state: string | null = null;
  no_nics_valid_permit_type: string | null = null;
  no_nics_valid_permit_number: string | null = null;
  no_nics_valid_permit_expiration_month: string | null = null;
  no_nics_valid_permit_expiration_day: string | null = null;
  no_nics_valid_permit_expiration_year: string | null = null;
  no_nics_valid_permit_issuance_month: string | null = null;
  no_nics_valid_permit_issuance_day: string | null = null;
  no_nics_valid_permit_issuance_year: string | null = null;

  // NICS background check details
  nics_transmission_month: string = '';
  nics_transmission_day: string = '';
  nics_transmission_year: string = '';
  nics_transaction_number: string | null = null;
  nics_initial_response: string | null = null;

  // Brady transfer
  brady_transfer_month: string | null = null;
  brady_transfer_day: string | null = null;
  brady_transfer_year: string | null = null;
  brady_transfer_number: string | null = null;

  // NICS follow-up
  nics_examiner: string | null = null;
  nics_secondary_response_type_prior_to_transfer: string | null = null;
  nics_secondary_response_date_prior_to_transfer: string | null = null;
  nics_secondary_response_type_post_transfer: string | null = null;
  nics_secondary_response_date_post_transfer: string | null = null;

  // FFL employee details
  ffl_employee_completing_nics: string | null = null;
  transferor_signature: string | null = null;
  transferor_certification_signature_day: string | null = null;
  transferor_certification_signature_month: string | null = null;
  transferor_certification_signature_year: string | null = null;
  transferor_name: string = '';
  transferor_notes: string | null = null;

  // FFL (dealer) information
  ffl: string = '';
  ffl_legal_name: string = '';
  ffl_company_name: string = '';
  ffl_address: string = '';
  ffl_address2: string = '';
  ffl_zip_code: string = '';
  ffl_city: string = '';
  ffl_state: string = '';
}

export class Form4473Transferee {
  id?: string;
  company_id?: string;
  name_first: string;
  name_middle: string;
  name_last: string;
  cadence?: string;
  address_street: string;
  address_zip_code: number;
  address_city: string;
  address_state: string;
  address_county: string;
  reside_in_city_limits?: 'yes' | 'no' | 'unknown' | null = null;
  birth_country: string;
  birth_state: string;
  birth_city: string;
  height_feet: number;
  height_inches: number;
  weight: number;
  sex: string;
  birth_year: string;
  birth_month: string;
  birth_day: string;
  social_security: string | null;
  upin: string | null;
  ethnicity: string;
  race: string[] = [];
  citizenship: string[] = [];
  alien_prefix: string | null;
  alien_number: string | null;
  question_a: boolean;
  question_b: boolean;
  question_c: boolean;
  question_d: boolean;
  question_e: boolean;
  question_f: boolean;
  question_g: boolean;
  question_h: boolean;
  question_i: boolean;
  question_j: boolean;
  question_k: boolean;
  question_l1: boolean;
  question_l2: boolean;
  transferee_cert: boolean;
  transferee_cert_month: string;
  transferee_cert_day: string;
  transferee_cert_year: string;
  transferee_cert_signature: string;
  transferee_recert_month: string | null;
  transferee_recert_day: string | null;
  transferee_recert_year: string | null;
  transferee_recert_signature: string;
  updatedAt?: string;
}
export class NicsReceived {
  ntn: string;
  ffl_rds_key: string;
  date_created: string;
  date_transfer: string;
  date_expiration: string;
  name_last: string;
  name_middle: string;
  name_first: string;
  cadence: string;
  gender: string;
  height: number;
  weight: number;
  race_ethnicity: string;
  date_birth: string;
  place_of_birth: string;
  upin: string;
  miscellaneous_no: string;
  miscellaneous_field: string;
  state_of_residence: string;
  citizenship_status: string;
  country_of_citizenship: string;
  country_of_citizenship2: string;
  country_of_citizenship3: string;
  purpose_id: string;
  submitted_by: string;
  retrieved_by: string;
  date_retrieved: string;
  status: string;
  date_status: string;
}
export class NicsSubmit {
  id_match: boolean;
  name_last: string;
  name_middle: string;
  name_first: string;
  cadence: string;
  initial_only: boolean;
  no_middle_name: boolean;
  state_of_residence: string;
  place_of_birth: string;
  height: number;
  weight: number;
  sex: string;
  date_birth: string;
  social_security: number;
  upin: string;
  is_hispanic_or_latino: boolean;
  race: string;
  citizenship_status: string;
  country_of_citizenship: string;
  country_of_citizenship2: string;
  country_of_citizenship3: string;
  nonimmigrant_w_visa_exception: string;
  miscellaneous_no: string;
  miscellaneous_field: string;
  transaction_purpose: string[];
  miscellaneous_info: string;
  contact_name: string;
  contact_phone: string;
  callback_hours: string;
}
export class Form4473FFL {
  ffl: string;
  legal_name: string;
  company_name: string;
  address: string;
  address2: string;
  zip_code: string;
  city: string;
  state: string;
}
export class Form4473Firearm {
  firearm_id: number;
  firearm_type: string;
  manufacture: string;
  importer: string;
  model: string;
  additional_markings: string;
  caliber_gauge: string;
  serial_number: string;
}
export class AvailableFirearm {
  firearm_upc: string;
  serial_number: string;
}
export class InventoryAlert {
  company_id: string;
  alert_selected_vendors: string[] = [];
  alert_desired_qty: number = 1;
  alert_item_upc: string;
  alert_item_name: string;
  alert_item_description: string;
  alert_text_number: string;
  alert_email: string;
  created_date: string;
  requestor: string;
}
export class AutoPurchase {
  company_id: string;
  auto_purchase_selected_vendors: string[] = [];
  auto_purchase_desired_qty: number = 1;
  auto_purchase_item_upc: string;
  auto_purchase_item_name: string;
  auto_purchase_item_description: string;
  auto_purchase_starting_date: string;
  auto_purchase_ending_date: string;
  auto_purchase_partial_orders_allowed: boolean;
  created_date: string;
  requestor: string;
}
export class PurchaseOptimizerItem {
  company_id: string;
  desired_qty: number = 1;
  item_upc: string;
  item_name: string;
  item_description: string;
  created_date: string;
  requestor: string;
  vendor_name?: string;
  vendor_cost?: number;
  selection_reasons?: string[];
}
export class PurchaseHistory {
  company_id: string;
  purchase_date: string;
  vendor_name: string;
  item_upc: string;
  item_name: string;
  item_description: string;
  desired_qty: number;
  purchase_qty: number;
  item_price: number;
  purchase_total: number;
  order_number: string;
}

export class FileInfo {
  file: File;
  file_format: string;
}
export class BulkAcquisitionItem {
  upc: string | null = null;
  serial: string[] = [];
  description: string | null = null;
}
export class FromValues {
  [key: string]: any;
}
export class ToValues {
  [key: string]: any;
}
export class UpdatedBoundBookResult {
  bound_book_id: string;
  bound_book: BoundBookEntry[];
}
export class OnHandFirearm {
  firearm_type: string;
  firearm_manufacturer: string;
  firearm_model: string;
  firearm_serial_number: string;
  firearm_caliber: string;
  acquisition_date: string;
}
export class ReservedFirearm {
  _id?: string;
  company_id?: string;
  bound_book_id: string;
  reservation_id: number;
  firearm_id: number | null = null;
  firearm: string | null = null;
  serial_number: string | null = null;
  reserved_date: string | null = null;
  reserved_to: string | null = null;
  reserved_by: string | null = null;
  notes: string | null = null;
}
export class Reserved4473 {
  id?: string;
  company_id?: string;
  full_name: string;
  address_street: string;
  birthday: string;
  nics_number: string;
  reserved_date: string;
}
export class ReservedInputs {
  reserved_for: string | null = null;
  reserve_notes: string | null = null;
}
export class ZoneSymbolValue {
  city: string;
  state: string;
}
export class ZoneSymbolObject {
  __zone_symbol__state: boolean;
  __zone_symbol__value: ZoneSymbolValue;
}
export class DistributorConfig {
  _id?: string;
  input_hash: string;
  distributor_name: string;
  username: string | null;
  password: string | null;
  sid: string | null;
  token: string | null;
  updated_datetime: string;
  updated_by: string;
}
export class DistributorInventoryProfile {
  name: string;
  selected: boolean;
  quantity?: number | null;
  price?: string | null;
  updated_datetime?: string;
  updated_by?: string;
}
export class BuildDisposition {
  reserved_firearms: ReservedFirearm;
  buyer_4473: Form4473Transferee;
  buyers_drivers_license: DriverLicense;
  seller_4473: Form4473Transferor;
}
export class ManualEnteredId {
  id_type: string;
  issuing_authority: string;
  id_number: string;
  name_first: string;
  name_middle: string;
  name_last: string;
  birth_date: string;
  issue_date: string;
  expiration_date: string;
  sex: string;
}
export class CapturedSignature {
  signature: string;
  signature_type: string;
}
export class Email {
  to: string;
  cc: string;
  bcc: string;
  subject: string;
  body: string;
  attachement?: any;
}
